<h3>Job Overview</h3>

<div class="border-1 bg-white px-4 py-2 border-round-lg border-gray-400">
  <h3>{{ jobNumber }}</h3>
  <p class="text-gray-700">{{ summaryText }}</p>

  <div class="flex gap-2 align-items-center my-4">
    <i class="fa fa-calendar"></i>
    <span>{{ startDate | datex : 'ddd DD MMM' }}</span>
    <div *ngIf="endDate != null">
      <i class="fa fa-arrow-right mr-1"></i>
      <span>{{ endDate | datex : 'ddd DD MMM' }}</span>
    </div>
  </div>

  <div class="flex gap-2 mb-2" *ngIf="carryoverCount != 0 || evCount != 0">
    <carryover-tag *ngIf="carryoverCount != 0" [count]="carryoverCount"></carryover-tag>

    <ev-tag *ngIf="evCount != 0" [count]="evCount"></ev-tag>
  </div>
</div>

<div *ngFor="let task of tasks; let taskIndex = index" class="my-2">
  <h4>Task {{ taskIndex + 1 }} of {{ tasks.length }}</h4>
  <travel-scheduler-summary-task
    [task]="task"
    (editScheduleClicked)="handleEditSchedule(taskIndex)"
  ></travel-scheduler-summary-task>
</div>
